import { render, staticRenderFns } from "./Pull.vue?vue&type=template&id=4cb53710&scoped=true"
import script from "./Pull.vue?vue&type=script&lang=js"
export * from "./Pull.vue?vue&type=script&lang=js"
import style0 from "./Pull.vue?vue&type=style&index=0&id=4cb53710&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb53710",
  null
  
)

export default component.exports